module.exports = __webpack_public_path__ + "static/media/banner_NumberKing-half.0ecb6a2c.png";